"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserPermission = void 0;
const getUserPermission = user => {
  const {
    projectAdmin
  } = user.accessLevels;
  return projectAdmin ? "Project administrator" : "Project member";
};
exports.getUserPermission = getUserPermission;
//# sourceMappingURL=getUserPermission.js.map